import { Component } from '@angular/core';
import { HoursApprovalReminder } from '@app/models/payroll/hours-approval-reminder.model';
import { BaseForm } from '@forms/base.form';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-send-hours-approval-reminder-form',
    templateUrl: './send-hours-approval-reminder.template.html',
})
export class SendHoursApprovalReminderForm extends BaseForm {
    hoursApprovalReminder: HoursApprovalReminder = new HoursApprovalReminder();
    isShowingBonusTaxWarning = false;

    constructor(private readonly translateService: TranslateService) {
        super();
        this.setDefaults();
    }

    reset(): void {
        this.setDefaults();
    }

    setDefaults(): void {
        this.hoursApprovalReminder.subject = this.translateService.instant(
            'payroll.run.showSendHoursApprovalReminderDefaultSubject'
        );
        this.hoursApprovalReminder.messageBody = this.translateService.instant(
            'payroll.run.showSendHoursApprovalReminderDefaultMessage'
        );
    }
}
